import React, { Component } from "react";
// import MainProfile from './MainProfile.jsx';
import InitialMainProfile from "./InitialMainProfile.jsx";
import { withStyles } from "@material-ui/core/styles";
import { compose } from "redux";
import { Button, TextField } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import LogoutAlert from "../../components/Alert/LogoutAlert.jsx";
import UpdateProfile from "./UpdateProfile.jsx";
import * as actions from '../../actions/index.js';
import { FormattedMessage, injectIntl } from "react-intl";
import { ROLE_CUSTOMER, ROLE_PROVIDER, SERVER_URL } from "../../utils/config/constants.js";
import { withRouter } from "react-router-dom";
import { AccountBalanceWallet, SearchIcon } from "@material-ui/icons";
import { connect } from "react-redux";
import { Clear, Add, Remove, ArrowLeft, ArrowRight, ArrowForward, ArrowBack, Category, AccessTime } from '@material-ui/icons';
import ContentLoader from "react-content-loader";
import { getCookies } from "../../utils/getToken.js";
import Axios from "axios";
import NavbarNew from "../../components/NavBarNew/NavbarNew.js";

class ManageBookingsScreenNew extends Component {
    constructor(props) {
        super(props);

        this.state = {
            // bookingSuccessDataPrev: this.props.history.location.state.bookingSuccessData.data,
            requestedData: [],
            confirmedData: [],
            rejectedData: [],
            completedData: [],
            inCartData:[],
            requestedHeading: "Requested",
            confirmedHeading: "Confirmed",
            rejectedHeading: "Rejected",
            completedHeading: "Completed",
            inCartHeading: "In Cart",
            loader: true
        };
    }
    componentDidMount() {
        // console.log("bookingSuccessDataPrev", this.state.bookingSuccessDataPrev);
        this.getBookingSummaryList()
    }

    componentWillUnmount() {
    }

    renderLoading = index => {
        return (
            <div style={{ width: '100%', margin: 10, }} key={index}>
                <ContentLoader
                    height={110}
                    width={600}
                    speed={2}
                    borderRadius={10}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="0" ry="0" width="97%" height="100" borderRadius="10px" />
                </ContentLoader>
            </div>
        );
    };

    getBookingSummaryList = async () => {
        var authToken = getCookies();
        try {
            const { data } = await Axios({
                method: 'get',
                url: `${SERVER_URL}/booking/owndata`,
                headers: { 'x-auth-token': authToken }
            });
            if(data.status == 'OK'){
                console.log("BOOKING SUMMARY DATA", data);
                this.setState({ 
                    loader: false,
                    bookingSummaryData: data.data, 
                    requestedData: data.data[1].requested,
                    confirmedData: data.data[2].confirmed,
                    rejectedData: data.data[3].rejected,
                    completedData: data.data[4].completed,
                    inCartData:data.data[5].incart,
                  });
            }
        } catch (e) {
            console.log("BOOKING SUMMARY error", e);
        }
    };

    render() {
        var summaryCard={
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 20,
            boxShadow: "1px 1px 20px #ddd",
            backgroundColor: '#fff',
            padding: 20,
            paddingTop: 30,
            alignItems: 'center',
            // textAlign: 'center',
            cursor: 'pointer',
            borderRadius: '10px'
        }
        var summaryCardLeft={
                display: 'flex',
                alignItems: 'center'
            }
        var summaryCardLength={
            fontSize: 30,
            fontWeight: 'bold',
            paddingRight: 25,
            color: '#0078ff'
        }
        // console.log(">>>>this.state.serviceDataPrev", this.state.serviceDataPrev);
        // console.log(this.props,' in profileDashboard')
        return (
            <div className="tz-2-com tz-2-main h4-padding">
                <div style={{ paddingBottom: "25px" }} className="db-list-com">
                    <div className="row">
                        <div className="col-md-12">
                            <NavbarNew
                                title='Booking Summary' 
                                goback={() => this.props.history.goBack(null)} 
                            />
                            <div>
                                <p 
                                id="booking_summary"
                                style={{
                                    fontSize: 30,
                                    marginBottom: 20
                                }}>Great place to see what's going on with your bookings</p>
                                <div>
                                    {
                                        this.state.loader 
                                        ? this.renderLoading()
                                        :
                                        <div 
                                        id="in_cart"
                                            style={summaryCard}
                                            onClick={()=> this.props.history.push('/user/bookings_list', 
                                            {heading : this.state.inCartHeading, bookingListData: this.state.inCartData })}
                                        >
                                            <div style={summaryCardLeft}>
                                                <AccessTime id="image" style={{fontSize: 50, color: 'grey', marginRight: 20}} />
                                                <div>
                                                    <p 
                                                    id="cart"
    
                                                    style={{
                                                        color: '#0078ff',
                                                        fontWeight: 'bold',
                                                        fontSize: 25
                                                    }}>In Cart</p>
                                                    <p>Bookings waiting for Payment</p>
                                                </div>
                                            </div>
                                            <p id="number" style={{...summaryCardLength, color: '#0078ff'}}>{this.state.inCartData.length}</p>
                                        </div>
                                    }
                                    {
                                        this.state.loader 
                                        ? this.renderLoading()
                                        :
                                        <div 
                                        id="in_cart"
                                            style={summaryCard}
                                            onClick={()=> this.props.history.push('/user/bookings_list', 
                                            {heading : this.state.requestedHeading, bookingListData: this.state.requestedData })}
                                        >
                                            <div style={summaryCardLeft}>
                                                <AccessTime id="image"  style={{fontSize: 50, color: '#636363', marginRight: 20}} />
                                                <div>
                                                    <p 
                                                    id="cart"
                                                    style={{
                                                        color: '#0078ff',
                                                        fontWeight: 'bold',
                                                        fontSize: 25
                                                    }}>Requested</p>
                                                    <p>Bookings waiting for a Service Pro's response</p>
                                                </div>
                                            </div>
                                            <p id="number" style={{...summaryCardLength, color: '#0078ff',}}>{this.state.requestedData.length}</p>
                                        </div>
                                    }
                                    {
                                        this.state.loader 
                                        ? this.renderLoading()
                                        :
                                        <div 
                                        id="in_cart"
                                            style={summaryCard}
                                            onClick={()=> this.props.history.push('/user/bookings_list', 
                                            {heading : this.state.confirmedHeading, bookingListData: this.state.confirmedData })}
                                        >
                                            <div style={summaryCardLeft}>
                                                <AccessTime id="image"  style={{fontSize: 50, color: '#636363', marginRight: 20}} />
                                                <div>
                                                    <p 
                                                     id="cart"
                                                    style={{
                                                        color: '#0078ff',
                                                        fontWeight: 'bold',
                                                        fontSize: 25
                                                    }}>Confirmed</p>
                                                    <p>Bookings accepted by a Service Pro</p>
                                                </div>
                                            </div>
                                            <p id="number" style={{...summaryCardLength, color: '#0078ff',}}>{this.state.confirmedData.length}</p>
                                        </div>
                                    }
                                    {
                                        this.state.loader 
                                        ? this.renderLoading()
                                        :
                                        <div 
                                        id="in_cart"
                                            style={summaryCard}
                                            onClick={()=> this.props.history.push('/user/bookings_list', 
                                            {heading : this.state.rejectedHeading, bookingListData: this.state.rejectedData })}
                                        >
                                            <div style={summaryCardLeft}>
                                                <AccessTime id="image"  style={{fontSize: 50, color: '#636363', marginRight: 20}} />
                                                <div>
                                                    <p 
                                                     id="cart"
                                                    style={{
                                                        color: '#0078ff',
                                                        fontWeight: 'bold',
                                                        fontSize: 25
                                                    }}>Rejected</p>
                                                    <p>Bookings rejected by you, because you weren't happy</p>
                                                </div>
                                            </div>
                                            <p id="number" style={{...summaryCardLength, color: '#0078ff',}}>{this.state.rejectedData.length}</p>
                                        </div>
                                    }
                                    {
                                        this.state.loader 
                                        ? this.renderLoading()
                                        :
                                        <div 
                                        id="in_cart"
                                            style={summaryCard}
                                            onClick={()=> this.props.history.push('/user/bookings_list', 
                                            {heading : this.state.completedHeading, bookingListData: this.state.completedData })}
                                        >
                                            <div style={summaryCardLeft}>
                                                <AccessTime id="image"  style={{fontSize: 50, color: '#636363', marginRight: 20}} />
                                                <div>
                                                    <p
                                                     id="cart"
                                                    style={{
                                                        color: '#0078ff',
                                                        fontWeight: 'bold',
                                                        fontSize: 25
                                                    }}>Completed</p>
                                                    <p>Bookings that were completed to your satisfaction</p>
                                                </div>
                                            </div>
                                            <p id="number" style={{...summaryCardLength, color: '#0078ff',}}>{this.state.completedData.length}</p>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ settings, categories, providers }) => {
    return {
        settings,
        categoryData: categories.categoryData,
        featuredProviderList: providers.featuredProviderList,
        featuredProviderLoader: providers.featuredProviderLoader
    };
};
const composedProfile = compose(connect(mapStateToProps, actions));
export default composedProfile(withRouter(ManageBookingsScreenNew));



// WEBPACK FOOTER //
// ./src/views/User/ManageBookingsScreenNew.jsx